<app-sidebar>
  <div class="page">
    <div class="page-header">
      <button mat-button type="button" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <h1>Digital Onboarding Results</h1>
    </div>

    <div class="loading-state" *ngIf="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf="!loading && dovs">
      <section>
        <h2>Consumer</h2>
        <dl>
          <dt>Reference</dt>
          <dd>{{ dovs.referenceNo || '—' }}</dd>
          <dt>ID</dt>
          <dd><span class="masked-id">{{ formatId(dovs.idNumberMasked || dovs.consumer?.idNo) }}</span></dd>
          <dt>Cell</dt>
          <dd><span class="masked-id">{{ formatCell(dovs.cellNumberMasked || dovs.consumer?.cellularNo) }}</span></dd>
          <dt>Name</dt>
          <dd>{{ displayName() }}</dd>
          <dt>Birth date</dt>
          <dd>{{ dovs.consumer?.birthDate || '—' }}</dd>
          <dt>Email</dt>
          <dd>{{ dovs.consumer?.emailAddress || '—' }}</dd>
          <dt>Address</dt>
          <dd>{{ dovs.consumer?.residentialAddress || '—' }}</dd>
        </dl>
      </section>

      <section *ngIf="dovs.dovDetails as dov">
        <h2>Verification</h2>
        <dl>
          <dt>Deceased status</dt>
          <dd>{{ dov.deceasedStatus || '—' }}</dd>
          <dt>ID photo match</dt>
          <dd>{{ dov.consumerIdPhotoMatch || '—' }}</dd>
          <dt>Match code</dt>
          <dd>{{ dov.matchResponseCode ?? '—' }}</dd>
          <dt>Liveness</dt>
          <dd>{{ dov.livenessDetectionResult || '—' }}</dd>
          <dt>Age estimate</dt>
          <dd>{{ (dov.ageEstimationOfLiveness != null && dov.ageEstimationOfLiveness >= 0) ? dov.ageEstimationOfLiveness : '—' }}</dd>
          <dt>Location</dt>
          <dd>
            {{ dov.streetNumber }} {{ dov.route }}, {{ dov.locality }}, {{ dov.country }}
            {{ dov.postalCode }}
          </dd>
          <dt>Coordinates</dt>
          <dd>{{ formatCoords(dov.latitude, dov.longitude) }}</dd>
        </dl>

        <div class="photos">
          <div *ngIf="photoSrc(dov.consumerIdPhoto) as idPhoto">
            <h3>ID photo</h3>
            <img [src]="idPhoto" alt="ID photo" />
          </div>
          <div *ngIf="photoSrc(dov.consumerCapturedPhoto) as capturedPhoto">
            <h3>Captured photo</h3>
            <img [src]="capturedPhoto" alt="Captured photo" />
          </div>
        </div>
      </section>
    </ng-container>
  </div>
</app-sidebar>
